import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CategoryCard } from '../components/CategoryCard';
import { BrandCard } from '../components/BrandCard';
import { categories } from '../data/categories';
import { mockOffers } from '../data/mockData';
export function ExplorePage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 pb-32 pt-8 px-4 md:px-8" data-id="element-315">
      <div className="max-w-7xl mx-auto" data-id="element-316">
        {/* Header */}
        <div className="mb-8" data-id="element-317">
          <h1 className="text-4xl font-serif font-bold text-gray-900 mb-2" data-id="element-318">
            Explore
          </h1>
          <p className="text-gray-500 text-lg" data-id="element-319">
            Browse categories to find cash back offers made for you.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-320">
          {categories.map(cat => <CategoryCard key={cat.id} name={cat.name} color={cat.color} image={cat.image} onClick={() => navigate(`/category/${cat.slug}`)} data-id="element-321" />)}
        </div>

        {/* All Brands Section */}
        <div className="mb-16" data-id="element-322">
          <div className="mb-8" data-id="element-323">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-2" data-id="element-324">
              All Brands
            </h2>
            <p className="text-gray-500 text-lg" data-id="element-325">
              Shop directly from your favorite brands and earn cash back.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-326">
            {mockOffers.map(offer => <BrandCard key={offer.id} offer={offer} data-id="element-327" />)}
          </div>
        </div>
      </div>
    </div>;
}